import React from "react";
import { Box, Text, VStack, HStack, Divider } from "@chakra-ui/react";
import { CheckCircle, AlertCircle, XCircle } from "lucide-react";

interface TaskDetailsProps {
  task: {
    name: string;
    plannedStart: string;
    plannedEnd: string;
    progress: number;
    status: string;
    description: string;
  } | null; // Allow task to be null if no task is selected
}

const TaskDetails: React.FC<TaskDetailsProps> = ({ task }) => {
  if (!task?.name) {
    return (
      <Box p={3} border="1px solid #CBD5E0" borderRadius="md" bg="white">
        <Text
          fontSize="xs"
          fontWeight="semibold"
          color="gray.600"
          textAlign={"center"}
        >
          No task details available
        </Text>
      </Box>
    );
  }

  const getStatusIcon = () => {
    switch (task.status) {
      case "Completed":
        return <CheckCircle color="green" size={"14px"} />;
      case "In-progress":
        return <AlertCircle color="yellow.400" size={"14px"} />;
      case "Not-started":
        return <XCircle color="red" size={"14px"} />;
      default:
        return null;
    }
  };

  return (
    <Box mt={4} p={4} borderRadius="md" bg="white" maxWidth="500px" mx="auto">
      <Text fontWeight="bold" fontSize="sm" mb={2}>
        {task.name}
      </Text>

      <Divider mb={4} />

      <VStack fontSize={"xs"} spacing={2} align="start">
        <HStack justify="space-between" width="100%">
          <Text fontWeight="semibold" color="gray.600">
            Start Date:
          </Text>
          <Text>{task.plannedStart}</Text>
        </HStack>

        <HStack justify="space-between" width="100%">
          <Text fontWeight="semibold" color="gray.600">
            End Date:
          </Text>
          <Text>{task.plannedEnd}</Text>
        </HStack>

        <HStack justify="space-between" width="100%">
          <Text fontWeight="semibold" color="gray.600">
            Progress:
          </Text>
          <Text>{task.progress}%</Text>
        </HStack>

        <HStack justify="space-between" width="100%">
          <Text fontWeight="semibold" color="gray.600">
            Status:
          </Text>
          <HStack spacing={2}>
            {getStatusIcon()}
            <Text>{task.status}</Text>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
};

export default TaskDetails;
